import { ErrorResponseHandler } from "../common/types";
import { ApiError } from "./observeApi";
import { ApiError as CnsApiError } from "./observeApi";

// errorToHandler translates a swagger error to a ErrorResponseHandler which
// is legacy, when all API calls are using the swagger API, we can remove this.
export const errorToHandler = (
  e: ApiError | CnsApiError,
): ErrorResponseHandler => {
  if (!e) {
    return {
      statusCode: 0,
      errorMessage: "",
      detailedError: "",
    };
  }
  return {
    errorMessage: e.message,
    detailedError: e.detailedMessage,
  };
};
